import React,{useEffect,useState} from 'react';
import { useGetTenantInfo} from '../../Hooks';
import { useSelector } from 'react-redux';
import { Box,Grid,Typography } from '@mui/material';
import {CircularProgress} from '@mui/material';
import TenantImageSelector from '../../../../components/GlobalComponents/ImageTenantSelector/ImageTenantSelector';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import {ReactComponent as ProfilVector} from '../../StaticData/Vectors/ProfileVector.svg';
import { useGetTenantPicture } from '../../Hooks';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import EditIcon from '@mui/icons-material/Edit';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import ChangeTenantInfo from '../../Forms/ChangeTenantInfo/ChangeTenantInfo';
import { useMediaQuery, useTheme } from '@mui/material';


const TenantInfo = () => {
    const[showToastMessge,setShowToastMessage]=useState(null)
    const[profileDetials,setProfileDetails]=useState<any>(null)
    const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
    const{data:personPictureData}=useGetTenantPicture(tenantId);
    const[imgSrc,setImgSrc]=useState<any>(null);
    const[changeImgData,setChangeImgData]=useState<any>(null)
    const personId=useSelector((state:any)=>state.loign.personId);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // بررسی موبایل بودن
    // console.log(personId);
    let body:any={
        tenantId:tenantId,
        personId:personId
    };
   
   //  const{data:personDetData,isLoading}=useGetUserProfileDetail(body);
    const{data:personDetData,isLoading}=useGetTenantInfo(body);

    
  useEffect(() => {
    
  if (personPictureData) {
    let{pictureBase64String}=personPictureData;
    setImgSrc(pictureBase64String)
  }
    }, [personPictureData])


    
   
    useEffect(() => {
      
    if (personDetData) {
        let{name,
            code,
            mission,

        }=personDetData;
        let details={
            name:name,
            code:code,
            mission:mission,
        }

        // setProfileDetails(detias)
        setProfileDetails(details)
    }
     
    }, [personDetData])


    const [showChangeEmail, setShowChangeEmail] = useState<boolean>(false);

    const initialChangeEmail= (): void => {
      setShowChangeEmail((prev) => !prev);
    };
   


    if (isLoading) {
        return  <Box py={5} textAlign={'center'} >
        <CircularProgress/>
        </Box>
    }



  return (
    <Grid container  >
    <Grid item xs={12} margin={1} >

   <Box sx={{bgcolor:'#E5F1FF',borderRadius:5,p:1,mx:'auto'}} width={'99%'}  >
    <Box display={'flex'} justifyContent={'start'}  >
    <Box width={'80%'} margin={1} >
    <img src={imgSrc} width={'200px'}  
    style={{borderRadius:'10%',boxShadow:'20px'}}
     />
    </Box>
    
    <Box >
        <TenantImageSelector setChangeImgData={setChangeImgData} setShowToastMessage={setShowToastMessage} />
    </Box>
    
    </Box>
    <Box
      width={isMobile ? '100%' : '60%'}  // در موبایل 100% و در وب 60%
      rowGap={2}
      margin={1}
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'column', // در موبایل عمودی و در وب افقی
        alignItems: 'flex-start', // برای موبایل
      }}
    >         <Box mt={1} display={'flex'} flexDirection={'row-reverse'} justifyContent={'start'}> 
            <Typography fontSize={'13px'} variant='h6' fontWeight={400}  >{profileDetials?.name}</Typography>
            <Typography fontSize={'14px'} variant='h6' fontWeight={600} > نام شرکت:</Typography>
            <Box >
            <Typography  variant='h6' fontWeight={400}>{profileDetials?.email}</Typography>
          <button
            onClick={(e: React.MouseEvent<HTMLElement>) =>
              initialChangeEmail()
            }
            className={`btn px-5  text-xs font-thin text-[#00387c]
               btn-sm rounded-md`}
          >
            <EditIcon/>
          </button> 
                 </Box>
         </Box>
         <Box mt={2} display={'flex'} flexDirection={'row-reverse'} justifyContent={'start'} > 
            <Typography fontSize={'11x'}   variant='h6' fontWeight={300}>{profileDetials?.code}</Typography>
            <Typography fontSize={'14px'} variant='h6' fontWeight={600}>کد دعوت:</Typography>
         </Box>
         <Box mt={2}  display={'flex'} flexDirection={'row-reverse'} justifyContent={'start'}> 
            <Typography fontSize={'13px'}   variant='h6' fontWeight={400}>{profileDetials?.mission}</Typography>
            <Typography fontSize={'14px'} variant='h6' fontWeight={600}>ماموریت:</Typography>
         </Box>
    </Box>
   
   </Box>
       
   <div>         
          <ModalLyt
            showModal={showChangeEmail}
            setShowModal={setShowChangeEmail}
            height={500}
            width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"اظلاعات شرکت"}
           
          >
            <ChangeTenantInfo
              // periodsData={perData}
              onSuccess={showChangeEmail}
              ceo={profileDetials?.name}
              setShowToastMessage = {setShowToastMessage}
              // setShowToastMessage={setShowToastMessage}
              //setAddObjectiveStatus = {setAddObjectiveStatus}
              // setObjectiveAsyncOpState={setObjectiveAsyncOpState}
              // afterSuccess={getObjectivesAgain}
              onClose={setShowChangeEmail}
            />
          </ModalLyt>
        </div>
    </Grid>
{/* 
    <Grid item xs={12}  >
    <Box display={'flex'} 
    p={3}
    flexDirection={'column'}
     alignItems={'start'} 
    justifyContent={'start'} 
    rowGap={1}
    >
     <Box>
        <Typography variant='body1'  fontWeight={900} >
        اطلاعات سازمانی
        </Typography>
     </Box>

     <Box display={'flex'}  >
     <Typography variant='body2' fontWeight={700}  >نقش:</Typography>
        <Typography>
         { profileDetials?.roleName}
        </Typography>
     </Box>
     <Box display={'flex'}>
        <Typography variant='body2' fontWeight={700}>تیم:</Typography>
        <Typography  variant='button' >{profileDetials?.teamName}</Typography>
     </Box>
     <Box display={'flex'}>
        <Typography variant='body2' fontWeight={700}>نام شرکت:</Typography>
        <Typography variant='button'>{profileDetials?.companyName}</Typography>
     </Box>
     <Box display={'flex'}>
        <Typography variant='body2' fontWeight={700}>نام مدیر:</Typography>
        <Typography variant='button'>{profileDetials?.managerName}</Typography>
     </Box>

    <Box sx={{mt:3}}>
        <Typography variant='body1'  fontWeight={900}>
        اطلاعات کاربری
        </Typography>
     </Box>
     <Box display={'flex'}>
        <Typography>تاریخ عضویت:</Typography><Typography>{profileDetials?.registerDate}</Typography>
     </Box>
    </Box>
    
    </Grid>
    <Grid item xs={12}  >
   <Box display={'flex'} flexDirection={'row-reverse'}  >
    <ProfilVector/>
   </Box>
   </Grid>
    */}
   {
      showToastMessge && <DYToastMessage
      isSuccess={true}
      message={'باموفقیت انجام شد'}
      setShow={setShowToastMessage}
      show={showToastMessge}
      
      />
      
      
    }
    </Grid>
  )
}

export default TenantInfo